import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { BlockService } from '../block.service'
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-block-table',
  templateUrl: './block-table.component.html',
  styleUrls: ['./block-table.component.scss']
})
export class BlockTableComponent implements OnInit {
  dataSource: any;
  displayedColumns: string[] = ['id', 'name', 'district_name'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private global: GlobalService, private http : HttpService, public service: BlockService) { 
    this.global.set_master_page_title = 'Block';
    this.getBlock();
    this.service.downloadBlock.subscribe((district) => {
      console.log(district);
      if (district) {
        this.getBlock();
      }
    });
  }
  getBlock() {
    this.http.getBlocks().subscribe((data: Block[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<Block>(data);
      this.dataSource.sort = this.sort;
    }, (error) => {
      console.log(error);
    });
  }

  registerBlock() {
    this.showBlockRegister();
    this.service.BlockUpdate.emit(null);
    this.service.set_block_data = null;
  }

  editBlock(element) {
    this.showBlockRegister();
    this.service.BlockUpdate.emit(element);
    this.service.set_block_data = element;
  }

  hideBlockRegister() {
    this.service.is_display_block_register_component = false;
  }

  showBlockRegister() {
    this.service.is_display_block_register_component = true;
  }

  ngOnInit() {
  }

}

export interface Block {
  id: number;
  name: string;
}